export const SECTION_9_TEXT = [
    "Certified translations are accepted by USCIS",
    "Accurate translation with attention to formatting and details",
    'Translators trained in birth certificate translation',
    'Secure delivery of your files',
    'Support with any additional services you need'
]

